import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './components/AuthContext';
import { useTheme } from './ThemeContext';
import App from './App';
import LoginPage from './components/pages/LoginPage';
import SubscriptionForm from './components/pages/pay';
import ProfilePage from './components/pages/ProfilePage';
import WaitingListPage from './components/pages/WaitingListPage';
import YesterdaySales from './components/pages/YesterdaySales';
import VideosPage from './components/pages/VideosPage';
import ReferralLinkPage from './components/pages/ReferralLinkPage';
import LoadingIndicator from './components/ui/LoadingIndicator';
import { Modal, Button } from 'react-bootstrap';
import { getMessaging, onMessage } from "firebase/messaging";
import { toast } from 'react-toastify';
import { FilterProvider } from './components/FilterContext';
import 'react-toastify/dist/ReactToastify.css';
import PublicLanding from './components/pages/PublicLanding';
const messaging = getMessaging();



const ProtectedRoute = ({ children }) => {
  const { isLoading, isAuthenticated } = useAuth();

  if (isLoading) return <LoadingIndicator />;
  if (!isAuthenticated) return <PublicLanding />;
  return children;
};
const getBrowserInfo = () => {
  const ua = navigator.userAgent.toLowerCase();
  return {
    isMobile: /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(ua),
    isIOS: /iphone|ipad|ipod/i.test(ua),
    isAndroid: /android/i.test(ua),
    isChrome: /chrome/i.test(ua)
      && !/edg|edge|yabrowser|yasearch|opera|opr|samsungbrowser|firefox|fxios|ucbrowser/i.test(ua),
    isSafari: /safari/i.test(ua)
      && !/chrome|crios|android|firefox|fxios|yabrowser|yasearch|opera|opr/i.test(ua),
    isYandex: /yabrowser|yasearch/i.test(ua),
    isDesktop: !/(android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini)/i.test(ua)
  };
};

const isPwaSupported = () => {
  const { isMobile, isIOS, isAndroid, isChrome, isSafari, isDesktop, isYandex } = getBrowserInfo();

  if (isDesktop) return true;

  if (isMobile) {

    if (isYandex) return false;

    if (isIOS) return isSafari;

    if (isAndroid) return isChrome;
  }

  return false;
};


const Root = () => {
  const { theme } = useTheme();
  const themeClass = theme === 'dark' ? 'bg-dark text-white' : 'bg-light text-dark';
  document.body.className = `App ${themeClass}`;

  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showInstallPrompt, setShowInstallPrompt] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [unsupportedBrowser, setUnsupportedBrowser] = useState(false);
  const [recommendedBrowser, setRecommendedBrowser] = useState(null);
  const [browserInfo, setBrowserInfo] = useState({});
  const [isStandalone, setIsStandalone] = useState(false);



  // Р РµРіРёСЃС‚СЂР°С†РёСЏ Service Worker
  useEffect(() => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.register('/service-worker.js', { updateViaCache: 'none' })
        .then((registration) => {
          registration.update().catch(() => { });

          if (registration.waiting) {
            setShowUpdateModal(true);
          }
          registration.onupdatefound = () => {
            const installingWorker = registration.installing;

            installingWorker.onstatechange = () => {
              if (installingWorker.state === 'installed' && navigator.serviceWorker.controller) {

                setShowUpdateModal(true);
              }
            };
          };
        })
        .catch((error) => {
          console.error('Ошибка при регистрации Service Worker:', error);
        });

      navigator.serviceWorker.addEventListener('controllerchange', () => {
        console.log('Service Worker обновлён, перезагрузка страницы...');
        window.location.reload();
      });
    }
    if ('Notification' in window && Notification.permission === 'granted') {
      try {

        const unsubscribe = onMessage(messaging, (payload) => {
          console.log('Получено сообщение в переднем плане:', payload);

          const notificationTitle = payload.data?.title || 'Новое уведомление';
          const notificationOptions = {
            body: payload.data?.body || 'Уведомление без текста',
            icon: payload.data?.icon || '/android-icon-96x96.png',
            data: {
              article: payload.data?.article,
              type: payload.data?.type
            }

          };

          const notification = new Notification(notificationTitle, notificationOptions);

          notification.onclick = () => {
            notification.close();
            const data = notification.data || {};
            const article = data.article;
            const type = data.type;

            let path = '/';
            if (type === 'pcw') {
              path = '/waiting-list';
            }

            const url = article
              ? `${window.location.origin}${path}?article=${encodeURIComponent(article)}`
              : window.location.origin + path;

            window.location.href = url;
          };
        });


        return () => {
          if (unsubscribe) unsubscribe();
        };
      } catch (error) {
        console.error('Ошибка при настройке обработчика уведомлений:', error);
      }
    }
  }, []);

  useEffect(() => {
    const browserData = getBrowserInfo();
    setBrowserInfo(browserData);

    const isInStandaloneMode = ('standalone' in navigator) && navigator.standalone;
    setIsStandalone(isInStandaloneMode);

    if (!isPwaSupported()) {
      setUnsupportedBrowser(true);
      return;
    }

    if (browserData.isAndroid && browserData.isChrome && !isInStandaloneMode) {
      const handleBeforeInstallPrompt = (e) => {
        e.preventDefault();
        setDeferredPrompt(e);
        setShowInstallPrompt(true);
      };

      window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
      return () => window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    }

    if (browserData.isIOS && browserData.isSafari && !isInStandaloneMode) {
      setShowInstallPrompt(true);
    }
  }, []);

  const handleInstallClick = async () => {
    if (!deferredPrompt) return;

    try {
      const result = await deferredPrompt.prompt();
      if (result.outcome === 'accepted') {
        toast.success('Установка началась! Проверьте домашний экран');
      }
    } catch (error) {
      toast.error('Ошибка установки: ' + error.message);
    } finally {
      setDeferredPrompt(null);
      setShowInstallPrompt(false);
    }
  };

  const handleCloseModal = () => {
    setShowInstallPrompt(false);
  };

  const handleUpdateApp = () => {
    navigator.serviceWorker.getRegistration().then(registration => {
      registration?.waiting?.postMessage({ type: 'SKIP_WAITING' });
    });
  };

  const BrowserRecommendation = () => {
    if (browserInfo.isYandex) {
      return (
        <div className="alert alert-danger">
          <h5>Используйте другой браузер</h5>
          <p>Яндекс.Браузер не поддерживает установку PWA</p>
        </div>
      );
    }

    if (browserInfo.isIOS) {
      return (
        <div className="alert alert-warning">
          <h5>Для iOS:</h5>
          <ol>
            <li>Откройте сайт в <strong>Safari</strong></li>
            <li>Нажмите <i className="fas fa-share"></i> → "На экран Домой"</li>
            <li>И откройте приложение через иконку на рабочем столе</li>
          </ol>
        </div>
      );
    }

    if (browserInfo.isAndroid) {
      return (
        <div className="alert alert-warning">
          <h5>Для Android:</h5>
          <p>Требуется Google Chrome</p>
          <a
            href="https://play.google.com/store/apps/details?id=com.android.chrome"
            className="btn btn-success"
            target="_blank"
            rel="noreferrer"
          >
            Установить Chrome
          </a>
          <p>После установки откройте приложение через Chrome</p>
        </div>
      );
    }

    return null;
  };

  return (
    <AuthProvider>
      <FilterProvider>
        <Router>
          <Routes>
            <Route path="/" element={<ProtectedRoute><App /></ProtectedRoute>} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/r/:refCode" element={<ReferralLinkPage />} />
            <Route path="/subscribe" element={<SubscriptionForm />} />
            <Route path="/profile" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
            <Route path="/waiting-list" element={<ProtectedRoute><WaitingListPage /></ProtectedRoute>} />
            <Route path="/yesterday-sales" element={<YesterdaySales
              closeModals={() => {
                setShowUpdateModal(false);
                setShowInstallPrompt(false);
                setUnsupportedBrowser(false);
              }}
            />} />
            <Route path="/videos" element={<VideosPage
              closeModals={() => {
                setShowUpdateModal(false);
                setShowInstallPrompt(false);
                setUnsupportedBrowser(false);
              }}
            />} />
          </Routes>
        </Router>
      </FilterProvider>
      <Modal show={showUpdateModal} onHide={() => setShowUpdateModal(false)} centered>
        <Modal.Header closeButton className={themeClass}>
          <Modal.Title>Доступно обновление</Modal.Title>
        </Modal.Header>
        <Modal.Body className={themeClass}>
          <Button variant="primary" onClick={handleUpdateApp} block>
            Обновить сейчас
          </Button>
        </Modal.Body>
      </Modal>

      <Modal show={showInstallPrompt} onHide={() => setShowInstallPrompt(false)} centered>
        <Modal.Header closeButton className={themeClass}>
          <Modal.Title>Установка приложения</Modal.Title>
        </Modal.Header>
        <Modal.Body className={themeClass}>
          {browserInfo.isIOS ? (
            <div>
              <div className="alert alert-info d-flex align-items-center">
                <i className="fab fa-apple me-2 fs-4"></i>
                <span>Инструкция для iOS</span>
              </div>
              <div className="d-grid gap-2">
              </div>
              <div className="mt-3">
                {[1, 2, 3].map(step => (
                  <div key={step} className="d-flex align-items-center mb-3">
                    <div className="me-2 badge bg-primary">{step}</div>
                    <span>
                      {step === 1 && 'Откройте сайт в Safari'}
                      {step === 2 && 'Нажмите "Поделиться" → "На экран Домой"'}
                      {step === 3 && 'Появится иконка на рабочем столе.'}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <div className="text-center">
              <p className="mb-4">Установите приложение для лучшего опыта!</p>
              <Button variant="primary" size="lg" onClick={handleInstallClick}>
                <i className="fas fa-download me-2"></i>
                Установить сейчас
              </Button>
            </div>
          )}
        </Modal.Body>
      </Modal>


      <Modal show={unsupportedBrowser} onHide={() => setUnsupportedBrowser(false)} centered>
        <Modal.Header closeButton className={themeClass}>
          <Modal.Title>⚠️ Требуется действие</Modal.Title>
        </Modal.Header>
        <Modal.Body className={themeClass}>
          <div className="text-center">
            <BrowserRecommendation />
          </div>
        </Modal.Body>
      </Modal>
    </AuthProvider>
  );
};

export default Root;

